import { buildEmpresaPatchFromCnpjLookup } from '@/utils/empresaCnpjLookup'
import type { CadastroClienteForm } from '@/components/ClientesAgrada/ClientesAgradaCadastroFields'

type CnpjEmpresa = Parameters<typeof buildEmpresaPatchFromCnpjLookup>[0]

/** Campos do cadastro que a consulta de CNPJ consegue preencher. */
export function cadastroPatchFromCnpjLookup(
  empresa: CnpjEmpresa,
  rawCnpj: string,
): Partial<CadastroClienteForm> {
  const patch = buildEmpresaPatchFromCnpjLookup(empresa, rawCnpj)
  const local = [patch.cidade, patch.estado].filter(Boolean).join('/')
  const cep = patch.cep ? `CEP ${patch.cep}` : ''
  const endereco = [patch.endereco, local, cep].filter(Boolean).join(' — ')
  const filled: Partial<CadastroClienteForm> = {}
  if (patch.nome) filled.nome = patch.nome
  if (endereco) filled.endereco = endereco
  if (patch.telefone) filled.telefone = patch.telefone
  if (patch.email) {
    filled.emailFinanceiro = patch.email
    filled.responsavelAssinaturaEmail = patch.email
  }
  return filled
}
